/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Created_TitleInputs */

const en_settings_apikeys_created_title = /** @type {(inputs: Settings_Apikeys_Created_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Key Created`)
};

/**
* | output |
* | --- |
* | "API Key Created" |
*
* @param {Settings_Apikeys_Created_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_created_title = /** @type {((inputs?: Settings_Apikeys_Created_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Created_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_created_title(inputs)
});
export { settings_apikeys_created_title as "settings.apikeys.created_title" }